module.exports = __webpack_public_path__ + "img/AzadGulladin-MawlanaKhalid.d2a17398.jpg";